import React from "react";
import QuitModal from "../../../common/Modal/QuitModal";
import NonCompliantPAF from "./NonCompliantPAF";
import ContinueNonCompliantPAF from "./ContinueNonCompliantPAF";
import ChangeValuesModal from "./ChangeValuesModal";
import ConfirmationModal from "./confirmationModal";
import OverdueWarningModal from "./OverdueWarningModal";
import FinishModal from "./FinishModal";

/** Non-route modals used from the PAF authorisation page. */
export function PafPageModals({
  modalNonCompliantPAF,
  closemodalNonCompliantPAF,
  continueButtonNonComplainPAF,
  handleChangeValidPassword,
  errorMessageFromServer,
  setValidPassword,
  hcp,
  displayWeeks,
  modalNonCompliantPAFWarning,
  closemodalNonCompliantPAFWarning,
  continueButtonNonComplainPAFWarning,
  changeValuesModalIsOpen,
  closeModalChangeValues,
  continueButton,
  quitModalIsOpen,
  closeModalQuit,
  quitModal,
  statePAFModal,
  closeConfirmationModal,
  message,
  submitError,
  submitValidate,
  handleChangeSelect,
  revert,
  form,
  handleChange,
  validateBeforeSending,
  errors,
  detailsPAF,
  continuDispenseOverduePAF,
  closeOverduePAF,
  continueWithOverduePAF,
  finishModalOpen,
  closeFinishModal,
  finishModalContent,
}) {
  return (
    <>
      {modalNonCompliantPAF.isOpen && (
        <NonCompliantPAF
          modalNonCompliantPAFIsOpen={modalNonCompliantPAF.isOpen}
          closemodalNonCompliantPAF={closemodalNonCompliantPAF}
          modalNonCompliantPAF={modalNonCompliantPAF}
          continueButtonNonComplainPAF={continueButtonNonComplainPAF}
          handleChangeValidPassword={handleChangeValidPassword}
          errorMessageFromServer={errorMessageFromServer}
          setValidPassword={setValidPassword}
          hcp={hcp}
          displayWeeks={displayWeeks}
        />
      )}

      {modalNonCompliantPAFWarning.isOpen && (
        <ContinueNonCompliantPAF
          modalNonCompliantPAFWarningisOpen={modalNonCompliantPAFWarning.isOpen}
          closemodalNonCompliantPAFWarning={closemodalNonCompliantPAFWarning}
          modalNonCompliantPAFWarning={modalNonCompliantPAFWarning}
          continueButtonNonComplainPAFWarning={
            continueButtonNonComplainPAFWarning
          }
        />
      )}

      {changeValuesModalIsOpen.isOpen && (
        <ChangeValuesModal
          changeValuesModalIsOpen={changeValuesModalIsOpen.isOpen}
          closeModalChangeValues={closeModalChangeValues}
          changeValuesModal={changeValuesModalIsOpen}
          continueButton={continueButton}
        />
      )}

      {quitModalIsOpen && (
        <QuitModal
          quitModalIsOpen={quitModalIsOpen}
          closeModalQuit={closeModalQuit}
          quitModal={quitModal}
          description="Are you sure you want to cancel filling out this form? All progress will be lost and you will need to start again."
        />
      )}
      {statePAFModal && (
        <ConfirmationModal
          statePAFModal={statePAFModal}
          closeConfirmationModal={closeConfirmationModal}
          message={message}
          submitError={submitError}
          submitValidate={submitValidate}
          handleChangeSelect={handleChangeSelect}
          revert={revert}
          form={form}
          handleChange={handleChange}
          handleErrors={validateBeforeSending}
          errors={errors}
          detailsPAF={detailsPAF}
        />
      )}

      {continuDispenseOverduePAF.isMainModalDisplayed && (
        <OverdueWarningModal
          continuDispenseOverduePAF={continuDispenseOverduePAF}
          closeOverduePAF={closeOverduePAF}
          continueWithOverduePAF={continueWithOverduePAF}
        />
      )}

      {finishModalOpen && (
        <FinishModal
          finishModalOpen={finishModalOpen}
          closeFinishModal={closeFinishModal}
          onFinish={finishModalContent.onFinish}
          description={finishModalContent.content}
          title={finishModalContent.title}
        />
      )}
    </>
  );
}
